import styled from "styled-components";
import { useContext, useEffect, useState } from "react";
import LoadingSection from "../../../helperComponents/LoadingSection";
import { serverLine } from "../../../../controllers/network/serverLine";
import goTo from "../../../../controllers/goTo";
import MaterialInput from "../../../helperComponents/MaterialInput";
import DropDownInput from "../../../helperComponents/DropDownInput";
import LoggedInBoilerplate from "../LoggedInBoilerplate";
import getUrlQuery from "../../../../controllers/getUrlQuery";
import ImagePicker from "../../../editors/ImagePicker";
import MapWithDraggableMarker2 from "../../../map/MapWithDraggableMarker2";
import contentPurposes from "../../../../data/contentPurposeTypes";
import CustomCheckbox from "../../../helperComponents/CustomCheckbox";
import DropDownLocationInput from "../../../helperComponents/DropDownLocationInput";
import PrimaryButton from "../../../helperComponents/PrimaryButton";
import ngoTypes from "../../../../data/ngoTypes";
import CustomButton from "../../../helperComponents/CustomButton";
import { GoLocation } from "react-icons/go";
import getGpsLocation from "../../../../controllers/customKarunaController/getGpsLocation";
import DropDropProfileSelection from "../../../helperComponents/dropDownUserSelection/DropDropProfileSelection";
import CustomLabel from "../../../applicationUI/CustomLabel";
import CertificateCardCore from "./CertificateCardCore";
import Context from "../../../../Context";

const initialLocation = { lat: 23.398831924485105, lng: 78.19784084625248 };

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 30px;
  /* margin-top: 100px; */
  align-items: center;
`;

const Inputs = styled.div`
  border-radius: 10px;
  display: flex;
  width: 600px;
  flex-direction: column;
  align-items: center;
  gap: 30px;

  @media (max-width: 900px) {
    width: 100%;
  }
`;

const InputItems = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 20px;
  gap: 20px;
  width: 100%;
  border-radius: 15px;
  background-color: var(--surface3);
  border: 1px solid var(--borderDim);
`;

const Row = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 15px;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

const Buttons = styled.div`
  width: 38vw;
  /* background-color: red; */
  display: flex;
  justify-content: center;
  align-items: center;
`;

const UploadSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  width: 100%;
`;

const MapSection = styled.div`
  width: 100%;
  height: 500px;
  border-radius: 15px;
  overflow: hidden;
`;

let dropDownStyle = { flex: 1 };

function formatDateForServer(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export default function IssueOrEditCertificate({}) {
  const { loggedInUser } = useContext(Context);
  const [itemId, setItemId] = useState(null);
  const [item, setItem] = useState({
    data: {
      title: "",
      description: "",
      issuedOn: formatDateForServer(new Date()),
    },
  });
  const [loading, setLoading] = useState(false);
  const [actionType, setActionType] = useState("ADD");
  const [selectedUser, selectUser] = useState(null);

  console.log("item", item);

  useEffect(() => {
    let newitemId = getUrlQuery("itemId");
    setItemId(newitemId);

    if (newitemId) setActionType("UPDATE");
  }, []);

  useEffect(() => {
    if (actionType == "UPDATE") {
      setLoading(true);
      if (itemId) {
        loadItemToBeEdited();
      }
    }
  }, [itemId]);

  let titleLine1 = "Issue";
  let titleLine2 = "Certificate";

  if (actionType == "UPDATE") {
    titleLine1 = "Edit";
    titleLine2 = "Certificate";
  }

  if (loading) {
    return (
      <LoggedInBoilerplate
        showBackButton={true}
        titleLine1={titleLine1}
        titleLine2={titleLine2}
      >
        <LoadingSection />
      </LoggedInBoilerplate>
    );
  }

  return (
    <LoggedInBoilerplate
      showBackButton={true}
      titleLine1={titleLine1}
      titleLine2={titleLine2}
    >
      <Container>
        <Inputs>
          <UploadSection>
            <ImagePicker
              value={item.data.customCertificate}
              onChange={(newValue) => {
                updateField("customCertificate", true, true)(newValue);
              }}
            ></ImagePicker>
            <CustomLabel>Custom Certificate Upload (Optional)</CustomLabel>
          </UploadSection>

          <InputItems>
            <Row>
              <MaterialInput
                label={"Title"}
                multiline={true}
                rows={2}
                value={item.data.title}
                onTextChange={updateField("title", true, true)}
              />
            </Row>

            <Row>
              <MaterialInput
                multiline={true}
                rows={15}
                label={"Description"}
                value={item.data.description}
                onTextChange={updateField("description", true, true)}
              />
            </Row>
          </InputItems>

          <InputItems>
            <Row>
              <DropDownLocationInput
                type="STATE"
                country="IN"
                value={item.data.state}
                onChange={updateField("state", true, true)}
              />

              <DropDownLocationInput
                country="IN"
                type="CITY"
                state={item.data.state}
                value={item.data.city}
                onChange={updateField("city", true, true)}
              />

              <DropDownInput
                options={ngoTypes}
                label="Field"
                value={item.data.type}
                onChange={updateField("type", true, true)}
              />
            </Row>
            <Row>
              <DropDropProfileSelection
                selectUser={selectUser}
                value={item.receiverUserId}
                onChange={updateField("receiverUserId", true)}
              />

              <MaterialInput
                label="Issued On"
                type="DATE"
                value={item.data.issuedOn}
                onChange={updateField("issuedOn", false, true)}
              />

              <MaterialInput
                label="Issued By"
                value={item.data.issuedBy}
                onChange={updateField("issuedBy", false, true)}
              />

              <MaterialInput
                label="Issuer Designation"
                value={item.data.issuerDesignation}
                onChange={updateField("issuerDesignation", false, true)}
              />
            </Row>
          </InputItems>

          {!item.data.customCertificate && (
            <CertificateCardCore
              ngo={loggedInUser}
              user={selectedUser}
              data={item.data}
            />
          )}

          <br />
          <Buttons>
            <PrimaryButton style={{ minWidth: "250px" }} onClick={save}>
              {actionType == "UPDATE"
                ? "Modify Certificate"
                : "Issue Certificate"}
            </PrimaryButton>
          </Buttons>
        </Inputs>
      </Container>
    </LoggedInBoilerplate>
  );

  function updateField(fieldName, isDirectValue, isSubField) {
    return (e) => {
      if (actionType == "UPDATE" && fieldName == "receiverUserId") {
        return window.popupAlert(
          "Recipient of the certificate can't be changed"
        );
      }

      setItem((newItem) => {
        newItem = { ...newItem };

        if (isSubField) {
          if (isDirectValue) {
            newItem.data[fieldName] = e;
          } else {
            newItem.data[fieldName] = e.target.value;
          }
        } else {
          if (isDirectValue) {
            newItem[fieldName] = e;
          } else {
            newItem[fieldName] = e.target.value;
          }
        }

        return newItem;
      });
    };
  }

  function save() {
    if (actionType == "UPDATE") editItem();
    if (actionType == "ADD") createItem();
  }

  async function loadItemToBeEdited() {
    let data = await serverLine.get(`/certificate/?itemId=${itemId}`);

    setItem(data);
    setLoading(false);
  }

  async function createItem() {
    setLoading(true);

    try {
      let res = await serverLine.post("/issue-certificate", {
        receiverUserId: item.receiverUserId,
        data: item.data,
      });

      window.popupAlert("Published");
      // goTo(`/p/${res.item._id}`)();
    } catch (e) {
      window.popupAlert(e.message);
    }

    setLoading(false);
  }

  async function editItem() {
    setLoading(true);

    try {
      let res = await serverLine.patch("/certificate", {
        itemId,
        changes: {
          data: item.data,
        },
      });

      window.popupAlert("Changes Published");
      // goTo(`/p/${res.item._id}`)();
    } catch (e) {
      window.popupAlert(e.message);
    }

    setLoading(false);
  }
}
